import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { ValidationService } from '../../services/formsValidation/validation.service';
import { FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { BorrowerRenderingService } from '../../services/borrower/borrower-rendering.service';
import { OTP } from '../../models/OTP/OTP';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { OTPformBuilderService } from '../../services/formsValidation/otpform-builder.service';
import { DLPRestUtilityService } from '../../services/rest/dlprest-utility.service';
import { HttpErrorResponse } from '@angular/common/http';
import { QuoteRenderingService } from '../../services/search/quote-rendering.service';
import { NewQuote } from 'src/app/models/search/new-quote';
import { submitOTPLabel_EN } from 'src/app/models/labels/submitOTPLabel_EN';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { BorrowerDTO } from 'src/app/models/borrower/borrower-dto';
import { IncomeDTO } from 'src/app/models/borrower/income-dto';
import { LoanStep1 } from 'src/app/models/borrower/loan-step1';
import { LoanStep2 } from 'src/app/models/borrower/loan-step2';
import { LoanStep3 } from 'src/app/models/borrower/loan-step3';
import { LoanStep4 } from 'src/app/models/borrower/loan-step4';
import { Parameter } from 'src/app/models/borrower/loanFormParameter';
import { QuotationEntityIdDto } from 'src/app/models/search/quotation-entity-id-dto';
import { SearchQuote } from 'src/app/models/search/search-quote';
import { DOCUMENT } from '@angular/common';
import { submitOTPLabel_HN } from 'src/app/models/labels/submitOTPLabel_HN';



@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss'],
})
export class DialogBoxComponent implements OnInit {


  onRegenerate = new EventEmitter();
  otp: OTP;
  errormessage: string;
  otpForm: FormGroup;
  otpFormErrors: any = {};
  content: any;
  otpField1: string = '';
  otpField2: string = '';
  otpField3: string = '';
  otpField4: string = '';
  otpField5: string = '';
  otpField6: string = '';
  maxHitFail: boolean = false;
  autoFocus: boolean = true;
  validOtp: boolean = false;
  applicantNum: string = '';
  label: any;
  fourDigitOtp: boolean = false; 
  mobileNum : any;
  email: string ='';
  emailFirst: string ='';
  emailLast: string ='';
  constructor(
    private OTPformBuilder: OTPformBuilderService,
    private validationService: ValidationService,
    private router: Router,
    private quoteRenderingService: QuoteRenderingService,
    private dlpRestUtilityService: DLPRestUtilityService,
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    private borrowerRenderingService: BorrowerRenderingService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) data: any,
    @Inject(DOCUMENT) private document: Document) {
    dialogRef.disableClose = true;
    this.content = data;
  }

  ngOnInit() {
    if(this.borrowerRenderingService.language){
      if(this.borrowerRenderingService.language==="ENGLISH"){
        this.label = new submitOTPLabel_EN();
      }else if(this.borrowerRenderingService.language==="HINDI"){
        this.label = new submitOTPLabel_HN();
      }
    }else{
      this.label = new submitOTPLabel_EN();
    }
    this.otp = this.borrowerRenderingService.OTP;
    this.mobileNum = this.content.phoneNum;
    this.email = this.content.email;
    if (this.content.phoneNum) {
      this.content.phoneNum = this.content.phoneNum.slice(6, 10);
    }
  
    if('generateOtpVerifyMobileEmail' == this.content.type)
    {
     this.fourDigitOtp =true;
    let str = this.email;
    let res = str.substring(0,2);
    let res1 = str.substring(str.indexOf('@'));
    let res2 = str.substring(0,str.indexOf('@'));
  
    for (let i=1; i<=res2.length-2;i++)
     {
      res+='*';
     }
  
    res=res+res1;

    this.emailFirst= res;
   
    }
   /* this.borrowerRenderingService.primaryBorrower.isEmailVerified = false;
    this.borrowerRenderingService.primaryBorrower.isMobileVerified = false;
    this.borrowerRenderingService.primaryBorrower.cstEmailDto[0].emailAddr="";
    this.borrowerRenderingService.primaryBorrower.cstPhoneDto[0].phoneNum=""; */

    this.buildForm();
  }

  buildForm() {
    this.otpForm = this.OTPformBuilder.buildOTPForm(this.otpForm, this.otp, this.fourDigitOtp);
    this.otpFormErrors = this.createFormError(this.otpForm);
    this.otpForm.valueChanges.subscribe((data) => {
      this.otpFormErrors = this.validationService.validateForm(this.otpForm, this.otpFormErrors, true);
    });
  }

  createFormError(formGroup: FormGroup) {
    let formErrors: any = {};
    let controls = formGroup.getRawValue();
    Object.keys(controls).forEach(control => {
      formErrors[control] = '';
    });
    return formErrors;
  }

  getDlpRefNum() {
    return this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
  }


  focusOnField() {
    if (this.autoFocus === false) {
      this.autoFocus = true;
    }
  }

  validation(event) {
    if (this.otpForm.invalid) {
      this.errormessage = 'Please enter Valid OTP';
    } else if (this.otpForm.valid) {
      this.errormessage = ' ';
    }
  }

  onSubmit() 
    {
     
      if( this.fourDigitOtp)
      {
       this.onSubmitToVerifyEmailMobile();
      }else{
      this.spinner.show();
      this.otp.otp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 + this.otpField5 + this.otpField6);
      this.otp.quotStatusId = 'TRACK_APPLN';
      this.otp.quotationNumber = this.borrowerRenderingService.loanStep2.indusRefId;
      this.otp.indCustQuotOtpId.custId = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
      this.otp.indCustQuotOtpId.portfolioId = this.quoteRenderingService.quotation.portfolioId;
      this.otp.indCustQuotOtpId.quotationId = this.quoteRenderingService.quotation.quotationId;
      this.otp.language=this.borrowerRenderingService.language;
      this.dlpRestUtilityService.sendOtp(this.otp)
        .subscribe(res => {
          let data: any = res;
          if (data.applicationNumber) {
            this.applicantNum = data.applicationNumber;
          } else {
            this.applicantNum = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
          }
          this.validOtp = true;
          this.spinner.hide();
        },
          (err: HttpErrorResponse) => {
            console.log('', err);
            if (err.error instanceof Error) {
              // A client-side or network error occurred.
              console.log('An error occurred:', err.error.message);
            } else {
              //  Backend returns unsuccessful response codes such as 404, 500 etc.
              console.log('Backend returned status code: ', err.status);
              console.log('Response body:', err.error);
              this.errormessage = err.error.errorMessage;
              if (err.error.uniqueId === 60002) {
                this.otpForm.reset();
              }
            }
            this.spinner.hide();
          }
        );
      }
    }

    onSubmitToVerifyEmailMobile() 
    {
      this.spinner.show();
      let enteredOtp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 );
      let data ={id:this.borrowerRenderingService.primaryBorrower.emailMobileVerifiedID,otp: enteredOtp, language: this.borrowerRenderingService.language , userId: "ren_dlp"};
      this.dlpRestUtilityService.sendOtpToVeifyEmailMobile(data)
        .subscribe(res => {
          let data: any = res;
          this.validOtp = true;
          // if('EMAIL' == this.content.emailMobileVerifyType )
          // {
          //   this.borrowerRenderingService.primaryBorrower.isEmailVerified = true;
          //   this.borrowerRenderingService.primaryBorrower.cstEmailDto[0].emailAddr=this.email;

          // }
          // else
          // {
          //   this.borrowerRenderingService.primaryBorrower.isMobileVerified = true;
          //   this.borrowerRenderingService.primaryBorrower.cstPhoneDto[0].phoneNum=this.mobileNum;

          // }
          if('EMAIL' == this.content.emailMobileVerifyType )
            {
              this.borrowerRenderingService.primaryBorrower.isEmailVerified = true;
              this.borrowerRenderingService.primaryBorrower.cstEmailDto[0].emailAddr=this.email;
    
            }
            if('SMS' == this.content.emailMobileVerifyType )
            {
    
    
              this.borrowerRenderingService.primaryBorrower.isMobileVerified = true;
              this.borrowerRenderingService.primaryBorrower.cstPhoneDto[0].phoneNum=this.mobileNum;
    
            }
    
            if('COBorrowerEMAIL' == this.content.emailMobileVerifyType )
              {
                this.borrowerRenderingService.primaryBorrower.isCoApplicantEmailVerified = true;
                this.borrowerRenderingService.coApplicantBorrower.cstEmailDto[0].emailAddr=this.email;
      
              }
              if('COBorrowerSMS' == this.content.emailMobileVerifyType )
              {
      
      
                this.borrowerRenderingService.primaryBorrower.isCoApplicantMobileVerified= true;
                this.borrowerRenderingService.coApplicantBorrower.cstPhoneDto[0].phoneNum=this.mobileNum;
      
              }



          this.spinner.hide();
        },
          (err: HttpErrorResponse) => {
            console.log('', err);
            if (err.error instanceof Error) {
              // A client-side or network error occurred.
              console.log('An error occurred:', err.error.message);
            } else {
              //  Backend returns unsuccessful response codes such as 404, 500 etc.
              console.log('Backend returned status code: ', err.status);
              console.log('Response body:', err.error);
              this.errormessage = err.error.errorMessage;
              if (err.error.uniqueId === 60002) {
                this.otpForm.reset();
              }
            }
            this.spinner.hide();
          }
        );
    }
  
  


  onRegenerateClick() {
    this.onRegenerate.emit();
    this.closeOTP();
  }

  onChange(event: any) {
    this.otpFormErrors = this.validationService.validateField(this.otpForm.controls[event.srcElement.id] as FormControl,
      this.otpFormErrors, event.srcElement.id, false);
    this.errormessage = this.otpFormErrors[event.srcElement.id];
    let element;
    if (event.key !== 'Backspace') {
      element = event.srcElement.nextElementSibling; // get the sibling element

      if (element == null) {  // check if its null
        return;
      } else {
        element.focus();
      }   // focus if not null
    } else if (event.key === 'Backspace') {
      element = event.srcElement.previousElementSibling;
      if (element == null) {  // check if its null
        return;
      } else {
        element.focus();
      }
    }
  }


  close() {
    this.dialogRef.close(this.content.otp);
  }

  saveForLater() {
    this.dialogRef.close(this.content.otp);
    this.quoteRenderingService.newQuote = new NewQuote();
    this.borrowerRenderingService.primaryBorrower = new BorrowerDTO();
    this.borrowerRenderingService.incomeBorrower = new IncomeDTO();
    this.borrowerRenderingService.loanStep1 = new LoanStep1();
    this.borrowerRenderingService.loanStep2 = new LoanStep2();
    this.borrowerRenderingService.loanStep3 = new LoanStep3();
    this.borrowerRenderingService.loanStep4 = new LoanStep4();
    this.borrowerRenderingService.parameter = new Parameter();
    this.borrowerRenderingService.coApplicantBorrower = new BorrowerDTO();

    this.quoteRenderingService.quotation = new QuotationEntityIdDto();
    this.quoteRenderingService.searchQuote = new SearchQuote();
    this.router.navigate(['/home']);
  }

  closeOTP() {
    this.dialogRef.close(this.content.otp);
    this.quoteRenderingService.newQuote = new NewQuote();
    this.borrowerRenderingService.primaryBorrower = new BorrowerDTO();
    this.borrowerRenderingService.incomeBorrower = new IncomeDTO();
    this.borrowerRenderingService.loanStep1 = new LoanStep1();
    this.borrowerRenderingService.loanStep2 = new LoanStep2();
    this.borrowerRenderingService.loanStep3 = new LoanStep3();
    this.borrowerRenderingService.loanStep4 = new LoanStep4();
    this.borrowerRenderingService.parameter = new Parameter();
    this.borrowerRenderingService.coApplicantBorrower = new BorrowerDTO();

    this.quoteRenderingService.quotation = new QuotationEntityIdDto();
    this.quoteRenderingService.searchQuote = new SearchQuote();
    this.router.navigate(['/home']);
  }

  resendOTPToVerifyMobileEmail() {
    this.spinner.show();
    this.otpForm.reset();
   
    let enteredOtp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 );
    let data ={id:this.borrowerRenderingService.primaryBorrower.emailMobileVerifiedID,otp: enteredOtp,language: this.borrowerRenderingService.language};
  
    this.dlpRestUtilityService.resendOtpToVeifyEmailMobile(data).subscribe(res => {
      this.spinner.hide();
      this.errormessage='';
    },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred.
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
          this.errormessage = err.error.errorMessage;
          this.otpForm.reset();
        }
        this.spinner.hide();
      }
    );
  }

  resendOTP() {

    if( this.fourDigitOtp)
    {
     this.resendOTPToVerifyMobileEmail();
    }else{

    this.spinner.show();
    this.otpForm.reset();
    this.otp.otp = +(this.otpField1 + this.otpField2 + this.otpField3 + this.otpField4 + this.otpField5 + this.otpField6);
    this.otp.quotStatusId = 'OTP_ENTERED';
    this.otp.quotationNumber = this.borrowerRenderingService.loanStep2.indusRefId;
    this.otp.indCustQuotOtpId.custId = this.borrowerRenderingService.primaryBorrower.cstCustomerEntityId.custId;
    this.otp.indCustQuotOtpId.portfolioId = this.quoteRenderingService.quotation.portfolioId;
    this.otp.indCustQuotOtpId.quotationId = this.quoteRenderingService.quotation.quotationId;
    this.otp.language=this.borrowerRenderingService.language;
    this.dlpRestUtilityService.resendOtp(this.otp).subscribe(res => {
      this.spinner.hide();
    },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred.
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
          this.errormessage = err.error.errorMessage;
          this.otpForm.reset();
        }
        this.spinner.hide();
      }
    );
  }
}

  validOtpSubmit() {
    if(this.fourDigitOtp)
    {
      this.close();
    }else
    {
    this.close();
    this.quoteRenderingService.newQuote = new NewQuote();
    // this.router.navigate(['/search/select', { id: 'new' }]);
    // this.document.location.href = 'https://www.renault.co.in/';
    this.router.navigate(['/thankyou']);
    }
  }
}
